import React from 'react';
import ColorPicker from 'material-ui-color-picker';
import { Icon, InputAdornment } from '@material-ui/core';
import { ClientContext } from '../../ClientContext';
import { homeContextInitial } from '../../../Home/HomeContext';
 
interface ClientColorPickerProps {
    name: string,
    color: string | null,
    setColor: (value: string | null) => void,
    colorError: boolean,
    setColorError: (error: boolean) => void,
    colorNotDefinedError: boolean,
}

export function ClientColorPicker({ name, color, setColor, colorError, setColorError, colorNotDefinedError }: ClientColorPickerProps) {

    const isColor = (strColor: string | null) => {
        if (strColor != null && strColor != '') {
            
            if (strColor.startsWith('RGBA')) {
                homeContextInitial.showWarning('Entre com a cor no formato hexadecimal ou preencha os campos de RGBA do componente para transformá-la para o formato hexadecimal');
                return false;
            }

            const s = new Option().style;
            s.color = strColor;
            return s.color !== '';
        }

        return true;
    };

    return (
        <ColorPicker
            showPicker
            name={name}
            id={name}
            variant='outlined'
            value={color ?? undefined}
            floatingLabelText={name}
            onChange={color => setColor(color)}
            onBlur={() => setColorError(!isColor(color))}
            InputProps={{
                endAdornment: color && (
                    <InputAdornment position="end">
                        <Icon className={'material-icons-round'} style={{ color: color }}>
                            square
                        </Icon>
                    </InputAdornment>),
                value: color ? color.toUpperCase() : undefined,
            }}
            InputLabelProps={{
                shrink: true,
            }}
            error={colorError || (colorNotDefinedError && !color)}
            helperText={colorError
                ? 'Cor inválida'
                : colorNotDefinedError && !color && 'Campo obrigatório'}
        />
    );
}